import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRobot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 443,
	height: 491,
	viewBox: "0 0 443 491",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M288.579 230.864C274.131 230.036 292.473 216.905 294.192 227.057C294.311 229.568 290.905 230.974 288.579 230.864ZM329.987 359.725C334.356 346.332 337.452 325.84 352.194 319.365C355.414 320.703 366.248 319.871 364.236 324.554C348.887 338.005 340.136 361.101 352.698 378.47C353.746 380.017 356.012 381.984 354.212 383.58C339.391 388.378 331.105 370.763 329.987 359.725ZM383.94 380.868C354.637 382.025 356.439 359.397 369.277 342.214C373.108 333.93 383.71 335.33 391.443 332.607C405.643 328.666 414.562 344.814 413.919 355.806C410.607 368.057 399.152 381.731 383.94 380.868ZM261.691 229.182C261.787 229.182 261.884 229.182 261.98 229.182C254.448 137.593 320.132 161.671 322.398 233.718C322 253.397 326.016 248.089 305.219 255.383C302.315 256.316 299.985 256.087 300.607 252.9C301.598 234.1 314.341 216.017 301.388 198.453C299.825 194.937 292.264 194.643 291.908 199.127C292.196 204.398 302.613 218.359 290.769 216.596C281.693 215.299 267.629 226.129 275.767 233.281C280.917 237.914 294.295 233.208 294.528 241.552C293.969 246.94 294.504 256.626 287.533 258.245C254.396 258.211 262.489 255.206 261.691 229.182ZM244.581 248.461C240.611 286.141 308.281 272.139 329.815 261.006C349.705 238.619 320.958 232.418 373.046 250.099C378.613 253.285 413.042 258.734 409.207 264.119C373.861 275.247 336.123 283.359 303.246 299.78C299.77 302.083 296.259 304.679 291.768 302.502C277.542 296.678 262.899 291.881 247.505 289.442C241.427 287.774 173.88 276.925 188.376 270.279C207.06 262.74 223.524 251.361 241.316 242.249C245.134 240.752 244.292 247.96 244.581 248.461ZM418.681 334.462C397.639 320.707 367.813 306.092 342.111 310.389C325.179 321.329 318.633 342.584 318.454 360.823C324.095 397.032 354.195 391.275 383.72 391.788C400.097 396.641 413.483 376.664 415.571 382.072C415.935 387.641 417.42 394.287 409.972 396.2C392.304 405.609 374.568 414.911 357.001 424.478C341.905 433.318 326.617 441.855 310.719 449.433C306.606 441.267 310.689 430.526 308.286 421.532C303.891 393.178 305.405 364.494 304.162 335.955C306.031 328.556 298.395 318.177 304.512 312.745C340.018 294.547 380.899 286.318 419.257 274.253C422.18 273.445 423.21 276.302 422.846 278.542C418.552 296.977 424.805 316.599 418.681 334.462ZM167.723 340.626C167.832 340.628 167.941 340.629 168.05 340.63C169.154 322.989 168.162 305.343 167.781 287.694C167.115 280.295 176.805 284.539 181.207 285.268C201.897 292.16 223.565 295.527 244.953 300.019C258.311 302.805 271.614 305.81 284.974 308.584C292.86 310.034 290.834 318.804 291.578 324.292C280.676 487.192 355.237 451.385 195.186 425.117C186.588 421.453 169.671 422.775 166.532 413.647C167.088 389.301 168.247 364.993 167.723 340.626ZM150.361 348.73C151.633 366.699 150.923 390.368 152.782 409.17C153.751 413.172 146.627 411.089 147.897 414.568C150.944 418.717 151.331 429.49 157.652 429.214C197.843 437.321 239.61 448.272 280.588 456.626C288.074 457.269 295.751 464.193 303.025 461.028C307.367 459.886 312.839 461.596 316.951 458.671C340.455 447.427 363.954 436.128 387.01 424.129C397.84 416.066 425.505 408.043 427.97 395.704C427.751 364.939 452.47 268.843 419.128 254.068C394.56 242.787 368.171 235.543 342.463 226.869C334.073 223.455 337.304 211.259 332.638 204.534C325.868 186.42 314.921 168.201 295.685 159.304C275.353 147.896 254.699 166.938 250.062 184.709C247.114 195.353 245.842 206.217 245.184 217.154C244.945 220.342 245.98 224.58 241.947 226.064C157.442 271.028 154.765 254.025 150.361 348.73Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M157.559 223.001C140.315 228.231 98.9426 219.171 94.0897 239.155C93.7354 242.017 96.9095 244.407 99.3638 242.724C117.829 234.162 140.163 237.904 159.392 230.783C165.677 228.906 164.502 221.89 157.559 223.001Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M115.068 318.888C115.344 329.26 125.641 366.613 138.888 349.691C139.981 339.217 132.199 329.369 129.706 319.239C125.009 299.136 118.126 300.116 115.068 318.888Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.0814 318.469C55.5075 319.496 2.67793 326.35 21.7434 338.205C31.1692 339.66 109.621 321.12 63.0814 318.469Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M377.995 204.017C388.709 200.827 427.324 198.194 430.164 188.825C423.7 178.905 385.322 191.066 374.314 194.062C368.564 197.939 369.416 205.623 377.995 204.017Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M56.1331 427.721C56.0895 432.263 62.3937 437.417 66.3516 433.848C78.1371 421.536 101.847 420.739 109.202 404.245C109.631 401.356 105.441 400.417 103.267 401.994C89.5922 411.924 61.7063 411.214 56.1331 427.721Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M160.582 181.219C164.808 189.828 193.11 225.404 203.324 219.993C208.5 217.782 205.312 212.245 202.732 209.318C194.529 203.094 170.629 172.793 160.582 181.219Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M370.446 119.137C377.75 116.498 437.87 117.221 426.371 105.89C417.785 102.496 324.546 111.424 370.446 119.137Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M354.35 66.9584C363.807 64.0658 392.599 57.1395 391.003 45.6777C381.005 39.6391 360.873 51.0791 349.988 54.2112C340.823 57.5408 343.341 69.2786 354.35 66.9584Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M313.708 85.3281C296.396 88.2582 336.093 120.15 343.008 110.236C345.507 99.1374 325.218 85.48 313.708 85.3281Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M380.564 454.536C385.962 460.837 403.361 487.249 412.835 479.769C420.18 473.524 384.353 436.47 380.564 454.536Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M367.143 150.059C370.889 161.419 372.585 178.196 383.732 184.872C401.482 188.023 371.641 128.551 367.143 150.059Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M51.1653 250.874C44.2081 253.21 50.0817 259.846 54.7168 261.347C67.8741 265.813 80.5338 277.76 94.561 277.058C96.6798 271.512 57.8499 250.224 51.1653 250.874Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M173.184 476.423C181.856 475.486 188.448 475.364 195.032 471.091C202.681 472.843 211.04 463.485 209.386 456.847C208.564 455.456 207.204 456.133 206.274 456.667C198.967 460.873 190.581 461.995 182.498 463.972C177.033 464.291 163.817 474.329 173.184 476.423Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M269.442 88.7552C283.914 86.1929 288.182 43.1116 269.468 61.1785C271.195 68.46 256.052 90.1879 269.442 88.7552Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.143803 450.082C6.18703 461.028 21.9606 465.627 31.9505 473.445C33.8575 475.056 37.3632 473.431 36.8206 471.128C29.4528 460.965 18.0075 453.185 8.25594 444.884C5.17982 442.907 -0.323193 447.029 0.143803 450.082Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M340.206 127.297C329.7 128.337 314.932 135.063 313.46 144.78C320.246 150.815 361.197 131.718 340.206 127.297Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M58.9653 381.882C57.5034 374.952 58.9268 361.553 51.6659 358.109C40.4843 358.466 48.0736 383.861 49.0663 390.62C55.3872 399.169 59.721 387.583 58.9653 381.882Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M138.992 476.038C136.778 468.252 129.066 448.732 118.564 450.283C109.884 454.061 136.26 493.575 138.992 476.038Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M210.399 99.8984C200.49 103.108 181.355 101.25 178.086 112.432C180.617 119.576 234.525 106.13 210.399 99.8984Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M423.371 433.819C430.149 434.324 453.132 431.496 437.864 424.203C417.574 416.89 389.145 432.013 423.371 433.819Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M268.374 481.052C272.053 473.544 252.648 457.389 249.365 468.854C249.151 478.157 268.996 504.266 268.374 481.052Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M110.984 190.88C120.189 205.555 129.423 168.972 129.656 162.79C122.596 153.419 112.265 185.889 110.984 190.88Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M188.223 146.961C189.174 175.155 203.719 152.781 202.524 138.936C201.138 129.69 186.032 132.9 188.223 146.961Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M358.974 463.764C359.014 461.29 356.829 456.533 353.524 459.095C348.69 465.014 333.367 474.229 337.501 481.845C347.55 484.692 357.677 472.128 358.974 463.764Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M407.946 159.353C414.715 159.259 445.096 153.151 430.173 144.93C423.711 143.239 389.986 156.461 407.946 159.353Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M408.574 237.643C417.75 250.545 430.072 213.506 416.664 212.391C409.205 217.642 411.677 229.491 408.574 237.643Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M262.607 134.875C258.947 135.638 239.286 136.541 246.946 143.263C256.138 144.179 265.589 146.159 274.709 143.284C283.114 135.926 268.772 135.222 262.607 134.875Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M412.074 75.0713C413.086 92.8584 432.599 51.4241 423.809 49.1875C413.48 50.4248 413.785 67.3661 412.074 75.0713Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M415.292 12.8056C426.761 9.93451 436.728 9.17487 419.077 3.6462C413.665 -0.712016 408.069 1.87369 402.494 2.27149C392.003 7.32127 409.723 13.0312 415.292 12.8056Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M342.605 173.344C315.452 176.037 349.381 184.35 351.96 178.004C352.287 174.551 346.343 173.563 342.605 173.344Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M242.191 406.903C248.324 405.952 262.48 411.69 263.798 404.726C264.745 402.425 265.028 399.336 261.98 398.276C237.984 393.646 213.085 394.133 189.225 387.828C164.732 404.347 232.471 407.372 242.191 406.903Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M190.34 336.042C191.685 345.655 191.027 377.836 207.846 361.909C206.961 355.131 209.6 314.399 198.759 318.8C188.387 322.572 191.54 327.902 190.34 336.042Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M243.444 351.841C239.439 368.066 257.026 375.211 262.324 358.364C263.307 351.581 263 325.684 252.927 327.29C245.221 333.378 243.433 343.401 243.444 351.841Z",
			fill: "#79C912",
			fillOpacity: .1
		})
	]
});
export default SvgRobot;
